import { PoolDetails } from "@/models/pool-details.model.ts";
import { Dialog } from "@capacitor/dialog";
import { computed, ComputedRef, ref } from "vue";
import i18n from "@/core/i18n.ts";

const KEY = "kwa_ble_pools";

export const storeBlePool = async (
  deviceId: string,
  poolDetails?: Partial<PoolDetails> & {
    localNickname?: string;
    token?: string;
  },
  options?: { autoConnect?: boolean; skipNickname?: boolean }
) => {
  const storedPools = readFromLocalStorage();

  const existing = storedPools.find((pool) => pool.deviceId === deviceId);

  const { t } = i18n.global;

  localStorage.setItem(
    KEY,
    JSON.stringify([
      ...storedPools.filter((pool) => pool.deviceId !== deviceId),
      {
        ...existing,
        ...poolDetails,
        deviceId,
        localNickname: options?.skipNickname
          ? undefined
          : poolDetails?.localNickname ??
            existing?.localNickname ??
            ((
              await Dialog.prompt({
                message: t("BleChoosePoolNameText"),
                inputText: poolDetails?.poolNickname,
              })
            ).value ||
              poolDetails?.poolNickname),
        autoConnect: options?.autoConnect ?? existing?.autoConnect ?? true,
      },
    ])
  );

  console.log("storing pool5");
  onPoolsChanged();
};

export const removeBlePool = (deviceId: string) => {
  const storedPools = readFromLocalStorage();
  localStorage.setItem(
    KEY,
    JSON.stringify(storedPools.filter((pool) => pool.deviceId !== deviceId))
  );
  onPoolsChanged();
};

const readFromLocalStorage = (): (PoolDetails & {
  deviceId: string;
  autoConnect: boolean;
  localNickname: string;
  token: string;
})[] => {
  return JSON.parse(localStorage.getItem(KEY) || "[]");
};

const _storedPools = ref(readFromLocalStorage());

const onPoolsChanged = () => {
  _storedPools.value = readFromLocalStorage();
};

export const useStoredBlePools = () => _storedPools;

export const useStoredBlePool = (deviceId: ComputedRef<string>) => {
  return computed(() =>
    _storedPools.value.find((pool) => pool.deviceId === deviceId.value)
  );
};
